require('./index.scss')
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchRelatedAssets } from '@/reducers/asset/asyncActions'
import { hasPdpRelatedAssetsSelector } from '@/selectors'
import { translate } from '@/utils/translations'

import SkeletonThemeWrapper from '../SkeletonThemeWrapper'
import Container from './Container'

const GTM_TYPE = 'gtm/onPdpRecommendations'

const PdpRelatedAssets = ({ assetId }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchRelatedAssets({ assetId: assetId }))
  }, [])

  const isLoading = useSelector(state => state.asset.relatedAssets.isLoading)
  const hasPdpRelatedAssets = useSelector(hasPdpRelatedAssetsSelector)

  useEffect(() => {
    if (hasPdpRelatedAssets) { dispatch({ type: GTM_TYPE }) }
  }, [hasPdpRelatedAssets])

  return (
    <Choose>
      <When condition={isLoading}>
        <SkeletonThemeWrapper height={window.innerWidth >= 768 ? 515 : 1356} />
      </When>

      <Otherwise>
        <div className='pdp_page__content__wrap'>
          <div className='related_products'>
            <h2 className='text-center text-md-left mb-3'>
              {translate('related_assets.related_products')}
            </h2>
            <Container />
          </div>
        </div>
      </Otherwise>
    </Choose>
  )
}

PdpRelatedAssets.propTypes = {
  assetId: PropTypes.number.isRequired
}

export default PdpRelatedAssets
